import { registerOnConsent } from "@rome2rio/tcf-api";
import { useEffect, useState } from "react";
import { useFeature } from "src/feature/useFeature";

/**
 * useRegisterOnConsent is a hook used to determine if a user has consented to the required purposes and legitimate interests
 *
 * @param consentPurposes - a list of required consent purposes
 * @param legitimateInterests - a list of required legitimate interests
 * @returns boolean - whether the user has consented to the required purposes and legitimate interests
 */
export function useRegisterOnConsent(
  consentPurposes: number[],
  legitimateInterests: number[],
  saleConsentRequired: boolean,
  sharingConsentRequired: boolean,
) {
  const [hasConsent, setHasConsent] = useState(false);
  useEffect(() => {
    registerOnConsent({
      onGiven: () => setHasConsent(true),
      onRevoked: () => setHasConsent(false),
      gdpr: {
        consentPurposesRequired: consentPurposes,
        legitimateInterestPurposesRequired: legitimateInterests,
      },
      us: {
        saleConsentRequired,
        sharingConsentRequired,
      },
    });
  }, [
    consentPurposes,
    legitimateInterests,
    saleConsentRequired,
    sharingConsentRequired,
  ]);

  // Our current CMP solution does not work on non-rome2rio.com
  // domains so we'll never achieve consent.
  const consent = useFeature("CmpConsent");
  if (consent === "deny") {
    return false;
  } else if (consent === "grant") {
    return true;
  }

  return hasConsent;
}
